import { useCurrentUserContext } from '#src/contexts/currentUser/index.ts';

export const useEnergyBalance = () => {
  const { currentUser } = useCurrentUserContext();

  return {
    energyBalance: currentUser?.energyBalance || [],
  };
};
